/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB4PSIxLjUiIHk9IjEuNSIgd2lkdGg9IjkiIGhlaWdodD0iOSIgcng9IjQuNSIgZmlsbD0iIzE5NzhCOCIgc3Ryb2tlPSIjQTVEM0YzIiBzdHJva2Utd2lkdGg9IjMiLz48L3N2Zz4=";